import { useLocation, useNavigate } from "react-router-dom";
import { useT } from "@/i18n/TranslationContext";

const LanguageSwitcher = ({ compact = false }) => {
  const { lang } = useT();
  const navigate = useNavigate();
  const location = useLocation();

  const switchTo = (target) => {
    if (target === lang) return;
    // On /thank_you we do not switch (single language page).
    if (location.pathname.startsWith("/thank_you")) return;

    const pathname = location.pathname;
    // Compute new path: replace leading /ar or /en (or "/") with new lang prefix.
    let rest = pathname;
    if (pathname === "/" || pathname === "") {
      rest = "";
    } else if (pathname.startsWith("/ar")) {
      rest = pathname.slice(3);
    } else if (pathname.startsWith("/en")) {
      rest = pathname.slice(3);
    }
    const newPath = `/${target}${rest}` || `/${target}`;
    sessionStorage.setItem("ecominarg:skipScroll", "1");
    navigate(newPath + location.hash);
  };

  const langs = [
    { code: "ar", label: "ES" },
    { code: "en", label: "EN" },
  ];

  return (
    <div
      className={`inline-flex items-center rounded-full border border-[#1f3555]/40 bg-white/70 backdrop-blur-sm ${
        compact ? "p-0.5" : "p-1"
      }`}
      role="group"
      aria-label="Language switcher"
    >
      {langs.map((l) => (
        <button
          key={l.code}
          onClick={() => switchTo(l.code)}
          data-testid={`lang-switch-${l.code}`}
          className={`px-3 py-1 text-xs font-semibold tracking-wide rounded-full transition-colors ${
            l.code === lang
              ? "bg-[#0b2545] text-white"
              : "text-[#0b2545] hover:bg-[#0b2545]/10"
          }`}
          aria-pressed={l.code === lang}
          type="button"
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
